import React from 'react';
import { CtaButton } from '../CtaButton';
import { ProductImage } from '../ProductImage';
import { PriceBlock } from '../PriceBlock';
import { BRAND, PRODUCT_NAME } from '../../data/salesContent';
export function FinalCtaSection() {
  return <section className="border-t border-zinc-800 bg-zinc-900 px-5 py-20 md:py-28" data-id="element-110" data-mp="2ik0yq7jl8krg">
      <div className="mx-auto max-w-3xl text-center" data-id="element-111" data-mp="2dik42trp5ujb">
        <ProductImage className="mx-auto w-full max-w-xl" data-id="element-112" data-mp="2riuujvp3h73y" />
        <p className="mt-12 text-sm font-bold uppercase tracking-[0.25em] text-amber-400 md:text-base" data-id="element-113" data-mp="2rhbdw3zj0u1n">{BRAND}</p>
        <p className="font-display mt-2 text-xl font-bold uppercase tracking-[0.15em] text-zinc-400 md:text-2xl" data-id="element-114" data-mp="2mhyr1j8nnmz2">{PRODUCT_NAME}</p>
        <h2 className="font-display mt-5 text-5xl font-black uppercase leading-[1] text-zinc-50 md:text-7xl" data-id="element-115" data-mp="2wa4f4hvsdk8z">
          Dejá de preparar cada capacitación <span className="text-amber-400" data-id="element-116" data-mp="3aa5grzjvkvpi">desde cero.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-zinc-400 md:text-xl" data-id="element-117" data-mp="368tsbxcqmgiw">
          Tené en un solo lugar contenidos técnicos, clases desarrolladas, escenarios educativos, evaluaciones y herramientas para organizar
          tus próximas capacitaciones.
        </p>
        <div className="mt-10 space-y-1" data-id="element-118" data-mp="2b0puszdoyci4">
          <p className="font-display text-2xl font-extrabold uppercase tracking-wide text-zinc-50 md:text-3xl" data-id="element-119" data-mp="2azy0drvtyktf">6 volúmenes + 5 bonos</p>
          <p className="text-sm font-bold uppercase tracking-widest text-amber-400 md:text-base" data-id="element-120" data-mp="2kzf8sh2gvct3">20 clases + 40 escenarios + 150 preguntas</p>
        </div>
        <div className="mt-6" data-id="element-121" data-mp="2ozha2p4ai47u">
          <PriceBlock data-id="element-122" data-mp="2oyo1dilrt4n2" />
        </div>
        <div className="mt-10" data-id="element-123" data-mp="2trh3rztro0vz">
          <CtaButton data-id="element-124" data-mp="2tsirb3ryyful">Quiero acceder al sistema completo</CtaButton>
        </div>
        <p className="mt-8 text-lg font-medium text-zinc-50 md:text-xl" data-id="element-125" data-mp="2ypilohfghu5v">
          Menos tiempo preparando materiales. <span className="text-amber-400" data-id="element-126" data-mp="33rhpfsf3yt3c">Más tiempo enseñando.</span>
        </p>
      </div>
    </section>;
}